import { getCurrentUser } from '../../../data/repositories/userRepository.js';

export const fetchCurrentUser = () => getCurrentUser();
